import { render, staticRenderFns } from "./RegisterForAnAccount.vue?vue&type=template&id=1adebfbe&"
import script from "./RegisterForAnAccount.vue?vue&type=script&lang=js&"
export * from "./RegisterForAnAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports